import RowActionsMenu from '../common/RowActionsMenu.js';

export const itclMenuFlags = (row, role) => {
  const unloaded = Boolean(row?.unloaded);
  const reverted = Boolean(row?.reverted);
  const lockReason = String(row?.lock_reason || '');
  const locked = Boolean(row?.on_ml_sheet) || /ml sheet/i.test(lockReason);
  if (reverted) {
    return {
      showUnload: false,
      showRevert: false,
      showRemove: false,
      canUnload: false,
      canRevert: false,
      canRemove: false,
      locked,
    };
  }
  return {
    showUnload: !unloaded,
    showRevert: unloaded,
    showRemove: true,
    canUnload: !unloaded && !locked,
    canRevert: unloaded && !locked,
    canRemove: !locked,
    locked,
  };
};

/**
 * 3-dot actions for an ITCL GC:
 * Unload only while pending. Revert after unload (back to pending).
 * Remove from request. Add note anytime.
 */
const ItclShipmentActionsMenu = ({
  row,
  role,
  menuKey,
  openMenuId,
  onToggle,
  onClose,
  onUnload,
  onRevert,
  onRemove,
  onNote,
  onView,
  disabled = false,
}) => {
  if (disabled || row?.reverted) return null;
  const flags = itclMenuFlags(row, role);
  const extraItems = [];
  if (flags.showUnload) {
    extraItems.push({
      key: 'unload',
      label: 'Unload',
      variant: 'primary',
      onClick: () => onUnload?.(row),
    });
  }
  extraItems.push({
    key: 'note',
    label: 'Add note',
    variant: 'default',
    onClick: () => onNote?.(row),
  });
  if (flags.showRevert) {
    extraItems.push({
      key: 'revert',
      label: 'Revert',
      variant: 'danger',
      onClick: () => onRevert?.(row),
    });
  }
  if (flags.showRemove) {
    extraItems.push({
      key: 'remove',
      label: 'Remove from ITCL request',
      variant: 'danger',
      onClick: () => onRemove?.(row),
    });
  }
  if (!extraItems.length && !onView) return null;
  return (
    <RowActionsMenu
      className="relative menu-container inline-flex"
      isOpen={openMenuId === menuKey}
      onToggle={onToggle}
      onClose={onClose}
      onView={onView}
      viewLabel="View"
      extraItems={extraItems}
    />
  );
};

export default ItclShipmentActionsMenu;
